module.exports = __webpack_public_path__ + "img/chart.e1a45704.svg";